
import { Card, CardContent } from "@/components/ui/card";
import { Investment } from "@/types/investment";
import { formatCurrency } from "./utils";

interface KeyMetricsCardsProps {
  investment: Investment;
}

const KeyMetricsCards = ({ investment }: KeyMetricsCardsProps) => {
  return (
    <div className="grid md:grid-cols-4 gap-4 mb-8">
      <Card>
        <CardContent className="p-4 text-center">
          <div className="text-2xl font-bold text-green-600 mb-1">
            {investment.yield}%
          </div>
          <div className="text-sm text-gray-600">Annual Yield</div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="p-4 text-center">
          <div className="text-2xl font-bold text-blue-600 mb-1">
            {formatCurrency(investment.askingPrice || investment.currentBalance)}
          </div>
          <div className="text-sm text-gray-600">Asking Price</div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="p-4 text-center">
          <div className="text-2xl font-bold text-purple-600 mb-1">
            {investment.ltv}%
          </div>
          <div className="text-sm text-gray-600">ITV Ratio</div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="p-4 text-center">
          <div className="text-2xl font-bold text-orange-600 mb-1">
            {investment.remainingTerms}
          </div>
          <div className="text-sm text-gray-600">Months Left</div>
        </CardContent>
      </Card>
    </div>
  );
};

export default KeyMetricsCards;
